var api = require("!../../../../../../../../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../../../../../../../node_modules/css-loader/dist/cjs.js??ref--10-1!../../../../../../../../../../../../node_modules/postcss-loader/src/index.js??postcss!../../../../../../../../../../../../node_modules/fast-sass-loader/lib/index.js!./style.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};